import * as React from "react";
import DefaultMapPage from "../../../common/DefaulMapPage/DefaultMapPage";

const ActiveCountries = () => (
  <DefaultMapPage title='30 countries'
                  subtitle='Real Estate Globally'
                  pageInfo='01 - hello'/>

);

export default ActiveCountries;
